<template>
  <widget-dropdown-select
    :options="options"
    :readonly="readonly"
    @update:model-value="$emit('select', $event)"
    @update:dropdown="$emit('update:dropdown', $event)"
    @hide="onHide"
  >
    <template v-slot:before-options>
      <div class="pt-4 pb-2 px-3">
        <widget-field-search
          class="widget-dropdown-search-select__search"
          :model-value="searchQuery"
          :placeholder="filterPlaceholder || $t('common.search')"
          autofocus
          @click.stop
          @update:model-value="$emit('update:search-query', $event)"
        />
      </div>
    </template>

    <template v-slot:selected-item="{ option }">
      <slot
        name="selected-item"
        :option="option"
      />
    </template>

    <template v-slot:option="{ option }">
      <slot
        name="option"
        :option="option"
      />
    </template>
  </widget-dropdown-select>
</template>

<script lang="ts">
import WidgetFieldSearch from '@widgets/shared/components/fields/WidgetFieldSearch.vue'
import WidgetDropdownSelect from '@widgets/shared/components/dropdown/WidgetDropdownSelect.vue'
import type { PropType } from '@/composition/vue/compositionApi'
import { defineComponent } from '@/composition/vue/compositionApi'
import type { SelectOption } from '@/services/forms/types'

export default defineComponent({
  components: {
    WidgetDropdownSelect,
    WidgetFieldSearch,
  },
  props: {
    searchQuery: {
      type: String,
    },
    options: {
      type: Array as PropType<SelectOption[]>,
      default: () => [],
    },
    filterPlaceholder: {
      type: String,
    },
    readonly: {
      type: Boolean,
    },
  },
  emits: {
    'update:search-query': (value: string) => true,
    select: (value: string) => true,
    'update:dropdown': (_val: boolean) => true,
    hide: () => true,
  },
  setup(props, context) {
    const onHide = () => {
      context.emit('hide')
      context.emit('update:search-query', '')
    }

    return {
      onHide,
    }
  },
})
</script>

<style lang="scss" scoped>
.widget-dropdown-search-select {
  &__search {
    min-width: 276px;
  }
}
</style>
